import * as yup from 'yup';
import {
  cannabisRequiredMessages,
  duplicateInvoiceError,
  maxCannabisReimbursementAmount,
} from 'Regex';
import { IInvoice } from 'Context/CannabisContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { defaultMinDate } from 'Config';

const dictionary = Dictionary[DICTIONARY.Reimbursements].form;

export const CannabisSchema = (
  checkIfInvoiceExists: (invoiceNumber: string) => boolean
) =>
  yup.object().shape({
    invoiceId: yup
      .string()
      .required(cannabisRequiredMessages.number)
      .test(
        'isDuplicateInvoiceNumber',
        duplicateInvoiceError,
        (value) => !checkIfInvoiceExists(value || '')
      ),
    invoiceDate: yup
      .date()
      .typeError(cannabisRequiredMessages.date)
      .nullable()
      .required(cannabisRequiredMessages.date)
      .max(new Date(), dictionary.futureDateError)
      .min(defaultMinDate, dictionary.pastDateError),
    invoiceTotal: yup
      .number()
      .typeError(cannabisRequiredMessages.amount)
      .nullable()
      .max(
        maxCannabisReimbursementAmount,
        cannabisRequiredMessages.maxAmountError
      )
      .min(1, cannabisRequiredMessages.minAmountError)
      .required(cannabisRequiredMessages.amount),
    file: yup.mixed().nullable(),
  }) as yup.SchemaOf<IInvoice>;
